import { useCallback, useRef, Dispatch, SetStateAction, MutableRefObject } from 'react';

type SetValue<T> = Dispatch<SetStateAction<T>>;

function useRefState<T>(initialValue: T): [MutableRefObject<T>, SetValue<T>] {
	const valueRef = useRef<T>(initialValue);

	const setValue = useCallback((newValue: SetStateAction<T>) => {
		if (typeof newValue === 'function') {
			valueRef.current = (newValue as (prevValue: T) => T)(valueRef.current);
		} else {
			valueRef.current = newValue;
		}
	}, []);

	return [valueRef, setValue];
}

export default useRefState;
